var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempleAttract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 743,
    height: 1080,
    viewBox: "0 0 743 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M592.714 884.6L842.116 1134L842.116 793.104L1183.01 793.104L933.612 543.702L1183.01 294.301L842.116 294.301L842.116 -46.5977L592.714 202.804L343.312 -46.5977L343.312 294.301L2.41414 294.3L251.816 543.702L2.41412 793.104L343.312 793.104L343.312 1134L592.714 884.6Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempleAttract);
export default __webpack_public_path__ + "static/media/temple-attract.ea8c319841d3f7de43a61124ead1eae5.svg";
export { ForwardRef as ReactComponent };